<template>
	<div class="layout">
		<div class="layout__header">
			<div class="layout__title">
				<h3>Motivos</h3>
			</div>
		</div>
		<div class="card">
			<div class="card__content">
				<k-table 
					ref="motivos" 
					@crear="crear" 
					:path="path" 
					@editar="editar" 
					@eliminar="eliminar" 
					:columns="[
						{
							display: 'Código',
							value: 'codigo',
						},
						{
							display: 'Motivo',
							value: 'descripcion',
						},
						{
							display: 'Tipo',
							value: 'tipo_descripcion',
						},
						{
							display: 'Creador',
							value: 'creador.nombre',
						},
						{
							display: 'Creación',
							value: 'created_at',
						},
						{
							display: 'Modificador',
							value: 'modificador.nombre',
						},
						{
							display: 'Modificación',
							value: 'updated_at',
						}
					]"
				></k-table>
			</div>
		</div>
		<modal name="motivo" scrollable resizable reset adaptive height="auto" width="60%">
			<motivo	
				@cancelar="cancelar"
				@saved="savedMotivo" 
				ref="motivo" 
				v-model="selectedMotivo"
			></motivo>
		</modal>
	</div>
</template>

<script>
export default {
	data: function () {
    return {
			path: url + "/motivos",
      selectedMotivo: null,
		}
	},
	methods: {
		cancelar: function () {
      this.$modal.hide("motivo");
    },
		savedMotivo: function () {
      this.$modal.hide("motivo");
      this.$refs.motivos.loadRows();
    },
		crear: function () {
      this.selectedMotivo = {
        estado: "N",
        codigo: "",
        descripcion: "",
				tipo: "",
        id: "",
        _method: undefined,
        codigo_sucursal: "",
      };
      this.$modal.show("motivo");
    },
		editar: function (motivo) {
			this.selectedMotivo = {
				codigo: motivo.codigo,
				descripcion: motivo.descripcion,
				estado: motivo.estado,
				tipo: motivo.tipo,
				id: motivo.id,
				_method: "PUT",
			};
			this.$modal.show("motivo");
		},
		eliminar: function (motivo) {
			swal({
        title:
          "¿Deseas " +
          (motivo.estado === "A" ? "inactivar" : "re-activar") +
          " el motivo?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/motivos/" + motivo.id, {
              _method: "DELETE",
            })
            .then(() => {
              swal(
                "El motivo ha sido " +
                (motivo.estado === "A" ? "inactivado" : "re-activado") +
                ".",
                "Realizado",
                "success"
              );
              this.$refs.motivos.loadRows();
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
		}
	}
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/general/Motivos.vue